<template>
  <calendar
    v-show="isShow"
    ref="modal"
    v-click-outside="onClickOutside"
    :style="{ position: 'absolute', ...position }"
    :option="option"
    :custom-date="customDate"
    :max-range-month="maxRangeMonth"
    class="calendar-modal rounded-8 shadow-dropdown p-3 z-1000 bg-white"
    @change="sendToParent"
    @toggle="$emit('toggle')"
  />
</template>

<script>
import Calendar from './Template.vue';

export default {
  name:       'CalendarModal',
  components: {
    Calendar,
  },
  props: {
    isShow: {
      type:    Boolean,
      default: false,
    },
    position: {
      type:    Object,
      default: null,
    },
    option: {
      type:    Number,
      default: 0,
    },
    customDate: {
      type:    Array,
      default: null,
    },
    maxRangeMonth: {
      type:    Number,
      default: 0,
    },
  },
  methods: {
    /**
     * При нажатие за пределом модалки, закрывает модалки
     */
    onClickOutside() {
      if (!this.isShow) return;

      this.$emit('toggle', false);
    },

    /**
     * Отправляет данные родителю
     *
     * @param {Date | String} date - выбранный дата
     * @param {Number} option - Индекс опций
     * @param {String} label - Текст из выбранных опций
     */
    sendToParent(date, option, label) {
      this.$emit('change', date, option, label);
    },
  },
};
</script>
